<template>
    <div class="container-fuluid">
      <div class="alert alert-danger alert-margin" role="alert" v-if="isMessage">
        {{ message }}
      </div>
      <div id="title" class="row">
        <div class="col-1">
          <svg id="header" class="bd-placeholder-img mr-2 rounded" width="28" height="28" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 32x32">
          <rect width="100%" height="100%" fill="#00C3E0"></rect>
          </svg>
        </div>
        <div class="col-7">
          <h5>displayName参照設定一覧</h5>
          電話の名前解決・着信履歴登録時のtargetNumberが以下の番号のときに、displayNameを参照して処理します
        </div>
      </div>
      <div id="main" class="row">
        <div class="col-1">
        </div>
        <div class="col-4">
          <table class="table table-sm table-hover form-table table-striped table-bordered">
            <thead>
              <tr>
                <th scope="col" style="width:80px"></th>
                <th scope="col">targetNumber</th>
              </tr>
            </thead>
            <tbody>
                <tr v-for="(targetNumber, index) in targetNumbers" v-bind:key="index">
                  <td>
                    <button type="button" class="btn-sm" v-on:click="remove(index)">
                      <img class="times-solid" src="/times-solid.svg">
                    </button>
                  </td>
                  <td>{{ targetNumber }}</td>
                </tr>
            </tbody>
          </table>
          <div class="row">
            <div class="col-8">
              <input type="text" maxlength="32" v-model="targetNumber" class="form-control" autocomplete="off" placeholder="targetNumber">
            </div>
            <div class="col-4">
              <button class="btn-sm btn-outline-info" type="submit" v-on:click="add()">追加する</button>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
          <div class="col-1">
          </div>
          <div class="col-4">
              <button id="register_button" class="btn btn-info btn btn-block" v-on:click="register()">更新する</button>
          </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios'
  import { sessions } from '../../mixin/session'
  import { path } from '../../mixin/path'
  import { headers } from '../../mixin/headers'
  
  export default {
    name: 'Index',
    mixins: [sessions,path,headers],
    props: ['realms'],
    data: function () {
      return {
        targetNumbers: [],
        targetNumber: "",
        message: ""
      }
    },
    mounted() {
      if (this.$store.getters.hospital.id !== 0) {
        this.init();
      }
      this.$store.watch(
        (state, getters) => getters.hospital,
        (newValue, oldValue) => {
          if (newValue.id != oldValue.id) {
            this.init();
          }
        }
      )
    },
    computed: {
      isMessage: function () {
        return this.message.length > 0
      }
    },
    methods: {
      async init() {
        let session;
        try {
          session = await this.$cognito.isAuthenticated();
        } catch (error) {
          this.message = error.message;
          return;
        }
  
        if (session) {
          try {
            const accessToken = this.getAccessToken(this.$cognito,session);
            const hospitalId = this.$store.getters.hospital.id;
            const response = await axios.get(`/api/setting/change/target-number/to/display-name/${hospitalId}`, {
              headers: this.headers(accessToken)
            });
            const data = response.data;
            if (data.errorMessage) this.message = data.errorMessage;
            this.targetNumbers = data.data;
          } catch (error) {
            this.message = error.message;
          }
        } else {
          this.$router.replace(this.replacePath(this.$cognito,this.realms,'/login'))
        }
      },
      remove(index) {
        this.targetNumbers.splice(index,1);
      },
      add() {
        this.targetNumbers.push(this.targetNumber);
        this.targetNumber = '';
      },
      async register() {
        let session;
        try {
          session = await this.$cognito.isAuthenticated();
        } catch (error) {
          this.message = error.message;
          return;
        }
  
        if (session) {
          try {
            const accessToken = this.getAccessToken(this.$cognito,session);
            const hospitalId = this.$store.getters.hospital.id;
            const response = await axios.put("/api/setting/change/target-number/to/display-name", {
              hospitalId: hospitalId,
              targetNumbers: this.targetNumbers
            }, {
              headers: this.headers(accessToken)
            });
            const data = response.data;
            if (data.errorMessage) {
              this.message = data.errorMessage;
            } else {
              this.message = "";
              alert("更新されました。");
            }
          } catch (error) {
            this.message = error.message;
          }
        } else {
          this.$router.replace(this.replacePath(this.$cognito,this.realms,'/login'));
        }
      }
    }
  }
  </script>
  
  <style scoped>
  #header {
    float: right;
  }
  #title {
    padding: 10px;
  }
  #main {
    height: 100%;
  }
  #register_button {
    margin-top: 30px;
  }
  .btn-sm{
    margin-left: 5px;
  }
  .alert-margin{
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
  .times-solid{
    cursor: pointer;
    height: 15px;
    width: 15px;
  }
  </style>